import { render, staticRenderFns } from "./TaskComponent.vue?vue&type=template&id=73ff4b22&scoped=true&"
import script from "./TaskComponent.vue?vue&type=script&lang=js&"
export * from "./TaskComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskComponent.vue?vue&type=style&index=0&id=73ff4b22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff4b22",
  null
  
)

export default component.exports